// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sjLQ2YgbRKrHizw_3d2g{display:flex;justify-content:center;width:100%}.sjLQ2YgbRKrHizw_3d2g button{width:80%;max-width:400px}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/Button/WideButton.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,sBAAA,CACA,UAAA,CAEA,6BACI,SAAA,CACA,eAAA","sourcesContent":[".buttonContainer{display:flex;justify-content:center;width:100%}.buttonContainer button{width:80%;max-width:400px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": `sjLQ2YgbRKrHizw_3d2g`
};
export default ___CSS_LOADER_EXPORT___;
